import { apiService } from "./index";

const responseSetService = {
  create(data) {
    return apiService.post("/response_sets", data);
  },

  get(id) {
    return apiService.get(`/response_sets/${id}`);
  },
};

export { responseSetService };
